export const filterPartiesByPartyTypeCode = (parties, partyTypeCode = []) => {
  if (partyTypeCode.length < 1 || !Array.isArray(partyTypeCode)) {
    console.error(
      "Please put desire party type codes as array in args for filtering."
    );
    return [];
  }
  return parties?.filter((party) =>
    partyTypeCode.includes(party.person.partyTypeCode)
  );
};
